import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";
import { TablePage } from "@outpave/ds";
import ApiKeyManagement from "components/admin/apiKeys/ApiKeyManagement";
import useGetLoggedInUser from "hooks/useGetLoggedInUser";
import ApiKeyScope from "enums/ApiKeyScope";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";

/** Platform API keys as their own route, like the company's API Access page. */
const PlatformApiAccess: React.FC = () => {
  const { t } = useTranslation();
  const { user: loggedInUser } = useGetLoggedInUser();
  const breadcrumbs = useNavBreadcrumbs(t("API Access"));
  const [createOpen, setCreateOpen] = useState(false);

  const platformId = loggedInUser?.platformId;

  return (
    <TablePage
      breadcrumbs={breadcrumbs}
      title={t("API Access")}
      subtitle={t("PlatformApiAccessDescription")}
      primaryAction={
        <Button
          variant="primary-filled"
          onClick={() => setCreateOpen(true)}
          disabled={!platformId}
        >
          {t("Create API key")}
        </Button>
      }
    >
      {platformId ? (
        <ApiKeyManagement
          scope={ApiKeyScope.PLATFORM}
          ownerId={platformId}
          createOpen={createOpen}
          onCreateOpenChange={setCreateOpen}
        />
      ) : (
        <Typography sx={{ color: "var(--color-text-secondary)" }}>
          {t("PlatformApiAccessUnavailable")}
        </Typography>
      )}
    </TablePage>
  );
};

export default PlatformApiAccess;
